// extracted by mini-css-extract-plugin
export var blink = "_71-2";
export var cursor = "_71-1";
export var reactMarkdown = "_71-3";
export var streamingText = "_71-0";